import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles/global.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15000, retry: 1, refetchOnWindowFocus: false } } });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#155eef', borderRadius: 10, colorBgLayout: '#f4f7fb', fontFamily: "Inter, 'PingFang SC', 'Microsoft YaHei', sans-serif" }, components: { Layout: { bodyBg: '#f4f7fb', siderBg: '#0b1739' }, Menu: { darkItemBg: '#0b1739', darkSubMenuItemBg: '#101f47', darkItemSelectedBg: '#155eef' } } }}>
      <AntApp><QueryClientProvider client={queryClient}><BrowserRouter><App /></BrowserRouter></QueryClientProvider></AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
